export default __webpack_public_path__ + "static/media/ExcelTemplate2.6fb8497f.xlsx";